import './PlayerColorSettings.styles.scss';

import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import React, { FC, useMemo, useState } from 'react';

import { Color } from '../../../model/enumeration/Color.enum';
import notificationStore from '../../../store/NotificationStore';
import playerColorStore from '../../../store/PlayerColorStore';
import { PlayerColorSettingsProps } from './PlayerColorSettings.types';

const PlayerColorSettings: FC<PlayerColorSettingsProps> = ({ pid }) => {
  const [visible, setVisible] = useState(false);

  const colors = useMemo(() => Object.values(Color), []);

  const selectedColor = useMemo(
    () => playerColorStore.getPlayerColor(pid),
    [playerColorStore.playersColors],
  );

  const handleColorChange = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    newColor: Color,
  ): void => {
    event.stopPropagation();
    const apiPromise =
      newColor === Color.UNSET
        ? playerColorStore.deletePlayerColor(pid)
        : playerColorStore.updatePlayerColor(pid, newColor);
    apiPromise
      .then(() => setVisible(false))
      .catch(() =>
        notificationStore.showNotification({
          severity: 'error',
          summary: 'Error',
          detail: `Error while updating player color`,
        }),
      );
  };

  const onOpenColorPanel = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ): void => {
    event.stopPropagation();
    setVisible(true);
  };

  const onMaskClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ): void => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <>
      <div
        className="PlayerColorSettings-Component"
        onClick={onOpenColorPanel}
        style={{
          backgroundColor: selectedColor,
          boxShadow:
            selectedColor === Color.UNSET ? '0 0 0 1px #949494' : undefined,
        }}
      />
      <Dialog
        className="PlayerColorSettings-Dialog"
        header="Choose the color"
        visible={visible}
        onHide={() => setVisible(false)}
        onMaskClick={onMaskClick}
        data-ignore-outside-click
        maskClassName="ignore-outside-click"
        dismissableMask
      >
        <div className="colors-wrapper">
          {colors.map(colorOption => (
            <div
              className="color"
              key={colorOption}
              onClick={e => handleColorChange(e, colorOption)}
              style={{
                backgroundColor: colorOption,
                boxShadow:
                  selectedColor === colorOption ? '0 0 15px gold' : undefined,
              }}
            />
          ))}
        </div>
      </Dialog>
    </>
  );
};

export default observer(PlayerColorSettings);
